$(document).on('change', '.custom-file-input', function () {
  const fileNames = Array.from(this.files || [], file => file.name);
  const fileName = fileNames.length > 0
    ? fileNames.join(', ')
    : $(this).val().replace(/\\/g, '/').replace(/.*\//, '');

  $(this).parent('.custom-file').find('.custom-file-label').text(fileName);
  $(this).siblings('.attachment-file-name').text(fileName);
});
